module.exports = __webpack_public_path__ + "img/Indobeauty.d87963a9.png";